<div class="sm:ml-64">
  <nav class="border-b bg-blue-50/30 ">
    <div class="flex flex-wrap items-center justify-between max-w-screen-xl p-4 mx-auto">
      <!-- Logo -->
      <a routerLink="/inspection/collection" class="flex items-center space-x-3 rtl:space-x-reverse">
        <span class="self-center text-2xl font-semibold text-gray-800">CERTIPORT</span>
      </a>

      <div class="flex items-center space-x-4">
        <!-- Profil utilisateur -->
        <div *ngIf="user" class="flex items-center space-x-3">
          <div class="flex-shrink-0">
            <!-- Badge avec initiales - Style amélioré -->
            <div
              class="flex items-center justify-center w-10 h-10 text-lg font-bold text-white transition-colors duration-200 bg-blue-600 rounded-full hover:bg-blue-700"
              [style.background]="user.profileColor || ''">
              {{ user.lastName.charAt(0).toUpperCase() }}{{
              user.firstName.charAt(0).toUpperCase() }}
            </div>
          </div>
          <div class="hidden sm:block">
            <p class="text-sm font-medium text-gray-800"
              *ngIf="user.role!='SUPER_ADMIN' &&  user.role != 'DIRECTEUR_TECHNIQUE' && user.role != 'CHEF_SEVICE_TECHNIQUE'">
              {{ user.lastName.charAt(0).toUpperCase() }}. {{ user.firstName }}
            </p>

            <p class="text-sm font-medium text-gray-800"
              *ngIf="user.role=='SUPER_ADMIN' || user.role === 'DIRECTEUR_TECHNIQUE' || user.role === 'CHEF_SEVICE_TECHNIQUE'">
              Espace Partenaires
            </p>

          </div>
        </div>

        <!-- Bouton menu mobile -->
        <button data-drawer-target="cta-button-sidebar" data-drawer-toggle="cta-button-sidebar"
          aria-controls="cta-button-sidebar" type="button"
          class="inline-flex items-center p-2 text-sm text-blue-600 transition-colors duration-200 rounded-lg sm:hidden hover:bg-blue-100/50 focus:outline-none focus:ring-2 focus:ring-blue-200 dark:text-blue-300 dark:hover:bg-blue-900/50 dark:focus:ring-blue-600">
          <span class="sr-only">Open sidebar</span>
          <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
            <path clip-rule="evenodd" fill-rule="evenodd"
              d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z">
            </path>
          </svg>
        </button>
      </div>
    </div>
  </nav>
</div>
